import { useState, useEffect, useContext, useCallback, FC, MouseEvent } from 'react'
import { Img } from 'react-image'
import { ClipLoader } from 'react-spinners'

import { ModuleContext } from '../contexts/ModuleContext'
import { simMod } from '../Module.config'
import { PartSpecsRequest, getPartSpecsImageURL } from '../api/api'
import { Part } from '../Types'
import { ModuleClass, SimutechModule } from '../ModuleTypes'
import { preventContextMenu } from '../Utils'

import './PartSpecsViewer.scss'
import { useLearningLab } from '../contexts/LearningLabContext'

type Props = {
    part: Part
    onClose: Function
}

export const PartSpecsViewer: FC<Props> = ({ part, onClose }: Props) => {
    const { user } = useContext(ModuleContext)
    const { state: { currentLab } } = useLearningLab()
    const [imgURL, setImgURL] = useState('')

    const fetchSpecs = useCallback(async () => {
        const partSpecRequest: PartSpecsRequest = {
            electricalCode: user.electricalCode,
            moduleId: simMod.type === ModuleClass.LL ? currentLab as SimutechModule : simMod.solverModule,
            partName: part.partID
        }
        const url = await getPartSpecsImageURL(partSpecRequest)

        if (url) setImgURL(url)
    }, [currentLab, user.electricalCode, part.partID])

    useEffect(() => {
        if (imgURL !== '') return
        fetchSpecs()

    }, [fetchSpecs, imgURL])

    return (
        <div onContextMenu={(e: MouseEvent) => preventContextMenu(e)} className='specs'>
            <div className='specs-container'>
                <div className='close-button' onClick={() => onClose()} />
                <div className="interactive img-wrapper">
                    <Img alt='' src={imgURL} key={imgURL} loader={<ClipLoader color={'white'} />} className='img-fluid' />
                </div>
            </div>
        </div>
    )
}
